export default "__VITE_ASSET__CEomMeK___"